import {Component, OnInit} from '@angular/core';
import {CommonService} from '@app/shared/services/common/common.service';
import {MatDialog} from '@angular/material/dialog';
import {LoaderService} from '@app/core/services/loader/loader.service';
import {Router} from '@angular/router';
import {PopupService} from '@app/shared/services/popup/popup.service';
import { NgxEditorModule } from 'ngx-editor';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css'],
  standalone:true,
  imports: [
    NgxEditorModule
    ]
})
export class PrivacyPolicyComponent implements OnInit {
  PrivacyContent: any;

  constructor(private commonService: CommonService, public dialog: MatDialog, private loaderService: LoaderService, private router: Router, private popupService: PopupService) {
  }

  ngOnInit() {
    this.fn_GetPrivacyPolicy();
  }

  fn_GetPrivacyPolicy() {
    this.commonService.getPrivacyPolicyAndTermsofUse().subscribe((res: any) => {
      if (res.StatusCode === 200) {
        if (res.Data.ResponseData != null) {
          this.PrivacyContent = res.Data.ResponseData.PrivacyPolicy;
        }
      }
    }, (err: any) => {
    });
  }

  openloginFormDialog() {
    this.popupService.openLogin();
  }
}
